// extracted by mini-css-extract-plugin
module.exports = {"status":"http-status_status__wkN27"};